import { getDefaultConfig } from '@rainbow-me/rainbowkit';
import { base } from 'wagmi/chains';

export const config = getDefaultConfig({
  appName: 'Dope Chain Wars',
  projectId: import.meta.env.VITE_WALLETCONNECT_PROJECT_ID || import.meta.env.VITE_WC_PROJECT_ID || '613ee03309496aafd17fc89d038e839b',
  chains: [base],
  ssr: false, // If your dApp uses server side rendering (SSR)
});
